import React, { useState, useEffect } from "react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import axios from "axios";
import Legends from "./components/Legends.jsx";
import VolumePricing from "./components/VolumePricing.jsx";
import SearchResults from "./components/SearchResults.jsx";
import LegendCantFind from "./components/LegendCantFind.jsx";
import Skeleton from "./components/Skeletons/Skeleton.jsx";
import SkeletonSearchBar from "./components/Skeletons/SkeletonSearchBar.jsx";


import SearchBar from "./components/SearchBar.jsx";

const LegendSearch = () => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const [isSingleType, setIsSingleType] = useState(true);
  const [pageOptions, setPageOptions] = useState({});
  const [clickCount, setClickCount] = useState(0);
  const [selectedPocketType, setSelectedPocketType] = useState(null);
  const [volumePricing, setVolumePricing] = useState(null);
  const [isFixed, setIsFixed] = useState(false);
  const [showSearched, setShowSearch] = useState(false);
  const [legends, setLegends] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [queryValue, setQueryValue] = useState("");
  const [customizationModels, setCustomizationModels] = useState([]);
  const [floatingTitle, setFloatingTitle] = useState("");

  let lastCrossedElement = null;
  const isRollUpPage = window.location.href.toLowerCase().includes("roll-up");
  const templateText =
    queryValue !== "" && filteredProducts.length === 0
      ? "&TemplateText=" + queryValue
      : "";

  const KEYS_TO_FILTERS = [
    "DisplayName",
    "ProductSuffix",
    "MUTCD",
    "MUTCD_Clean",
  ];

  useEffect(() => {
    if (clickCount > 0) {
      handleClickCount;
    }
  }, [clickCount]);

  const handleClickCount = (e) => {
    const selectedPocketTypeValue = e.target.value;
    setClickCount((prevCount) => prevCount + 1);
    if (clickCount === 0) {
      setSelectedPocketType(Number(selectedPocketTypeValue));
    }
  };

  const handleResults = (filteredResults) => {
    if (filteredResults && filteredResults.length > 0) {
      setFilteredProducts(filteredResults);
    } else {
      setFilteredProducts([]);
    }
  };

  const handleQueryValue = (query) => {
    setQueryValue(query);
  };

  useEffect(() => {
    function handleScroll() {
      const fixedElement = document.querySelector(".fixed");

      if (fixedElement) {
        const fixedRect = fixedElement.getBoundingClientRect();
        const fixedBottom = fixedRect.bottom + window.pageYOffset;

        const searchContainerNames = document.querySelectorAll(
          ".search-container-name"
        );

        searchContainerNames.forEach((el, index) => {
          const rect = el.getBoundingClientRect();
          const elementBottom = rect.bottom + window.pageYOffset;

          if (window.pageYOffset > elementBottom - fixedElement.offsetHeight) {
            // Update the state only if the crossed element has changed
            if (lastCrossedElement !== el) {
              lastCrossedElement = el;
              setFloatingTitle(el.innerHTML);
              console.log("crossed element:", el.innerHTML);
            }
          }
        });

        // Reset floatingTitle if scrolling back up past the first element with a buffer threshold
        if (searchContainerNames.length > 0) {
          const firstElementTop =
            searchContainerNames[0].getBoundingClientRect().top +
            window.pageYOffset;
          // debugger

          // Use a threshold to ensure the reset happens only when clearly above the first element
          if (window.pageYOffset < firstElementTop - 100) {
            // 100px buffer threshold

            if (floatingTitle !== "") {
              setFloatingTitle("");
              console.log("Reset to empty title");
              lastCrossedElement = null;
            }
          }
        }
      }
    }

    // Attach the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [floatingTitle]); // Dependency array includes floatingTitle to ensure it updates correctly

  const handleScroll = () => {
    const scrollerAnchor = document.getElementById("scroller-anchor");

    if (scrollerAnchor) {
      const anchorPosition = scrollerAnchor.getBoundingClientRect().top;
      if (anchorPosition <= 0 && !isFixed) {
        document.body.style.overflowX = "unset";
        document.documentElement.style.overflowX = "unset";
        setIsFixed(true);
      } else if (anchorPosition > 0 && !isFixed) {
        document.body.style.overflowX = "";
        document.documentElement.style.overflowX = "";
        setIsFixed(false);
      }
    }
  };
  // Load products when component mounts
  useEffect(() => {
    loadProducts();
    window.addEventListener("scroll", handleScroll);

    return () => {
      // Cleanup on unmount
      window.removeEventListener("scroll", handleScroll);
      document.body.style.overflowX = "";
      document.documentElement.style.overflowX = "";
    };
  }, []);

  // Fetch products
  const loadProducts = () => {
    const productType = "roll-up";

    axios
      .post("/Product/CustomLegendPageLoad", {
        groupedProductId: groupedProductId,
        productType: productType,
      })
      .then((response) => {
        setIsSingleType(response.data.SingleTypeMode);
        setLegends(response.data.Legends);
        setPageOptions(response.data.PageOptions);
        setHasLoaded(true);
        setSelectedPocketType(
          response.data.PageOptions.DefaultSelectedAttributeId
        );
        setVolumePricing(response.data.ProdGroupPrices);
        setCustomizationModels(response.data.CustomizationModels);
      })
      .catch((error) => {
        console.error("There was an error fetching the products!", error);
      });
  };
  return (
    <div className="tiled-card-page" id="legends">
      {hasLoaded && 
        <SearchBar
          legends={legends}
          filterViaSearchBar={handleResults}
          setShowSearched={setShowSearch}
          handleQueryValue={handleQueryValue}
      />}
        {/* {!hasLoaded && <SkeletonSearchBar /> }  */}
       {!hasLoaded
        ? isRollUpPage ? <Skeleton pagetype={"double"}/> : <Skeleton pagetype={"single"}/>
        : null}

      

      <div id="scroller-anchor"></div>

      {hasLoaded &&  volumePricing ? (
        <VolumePricing
          volumePricing={volumePricing}
          isFixed={isFixed}
          isSingleType={isSingleType}
          floatingTitle={floatingTitle}
          // for nested cantfind component
          filteredNumber={filteredProducts.length}
          customizationModels={customizationModels}
          templateText={templateText}
          showSearched={showSearched}
        />
      ) : null}

      {showSearched && (
        <div>
          {filteredProducts.length !== 0 && showSearched ? (
            <div className="search-container-name col-sm-12 col-md-2 legendsHeaderBox">
              Search Results
            </div>
          ) : null}
          <SearchResults
            results={filteredProducts}
            selectedPocketType={selectedPocketType}
            singleType={isSingleType}
            pageOptions={pageOptions}
            searchTerm={queryValue}
            clickCount={clickCount}
            onOptionClick={handleClickCount}
          />
        </div>
      )}

      {filteredProducts.length !== 0 && showSearched ? (
        <div className="search-container-name col-sm-12 col-md-2 legendsHeaderBox">
          All Legends
        </div>
      ) : null}
  {hasLoaded && (
    legends.map((legend, index) => {
      return (
        <Legends
          singleType={isSingleType}
          pageOptions={pageOptions}
          legend={legend}
          index={index}
          key={index}
          onOptionClick={handleClickCount}
          selectedPocketType={selectedPocketType}
          clickCount={clickCount}
        />
      );
    })
  )}
      {/* {legends.map((legend, index) => {
        return (
          <Legends
            singleType={isSingleType}
            pageOptions={pageOptions}
            legend={legend}
            index={index}
            key={index}
            onOptionClick={handleClickCount}
            selectedPocketType={selectedPocketType}
            clickCount={clickCount}
          />
        );
      })} */}

      {customizationModels != [] && customizationModels.length > 0 && (
        <LegendCantFind
          customizationModels={customizationModels}
          templateText={templateText}
        />
      )}
    </div>
  );
};

// Initializing React root
const domNode = document.getElementById("legendSearch");
const root = createRoot(domNode);

root.render(
  <StrictMode>
    <LegendSearch />
  </StrictMode>
);
